export default __webpack_public_path__ + "static/port-800cea820870299c92687511725b6f45.jpg";